module.exports = __webpack_public_path__ + "static/media/horizontal-ellipsis.e1857e9d.svg";